/* Ardor Printing AI T-Shirt Design Generator (/pages/ai-tshirt-design-generator, sections/ardor-dtf-idea.liquid). New Oct 14, 2026 (DTF-AI).
Talks to the same AI server routes as the AI sticker generator (assets/ardor-idea.js), no server change:
GET /api/quota, POST /api/generate { idea, style, visitor, email, token }, POST /api/edit { imageId, change, visitor, email, token },
GET /img/<id>. Same visitor id and email (localStorage wsIdeaVisitor / wsIdeaEmail), same invisible Cloudflare Turnstile check and
the same email unlock, so the free tries are shared with the sticker generator.
The sticker routes return isolated art as transparent PNGs. window.ArdorDtfCutout (assets/ardor-dtf-ai-cutout.js) checks that,
makes near-opaque px fully opaque, drops specks and trims (and would remove a plain backdrop, with feathered edges, if an image
ever came with one), then each design is drawn on a 2D t-shirt (12 colours, 4 spots, true to size). "Use this design" opens the DTF transfer designer:
  <builder>?ai=<id>&src=sticker&placement=<front|leftchest|back|sleeve>   + sessionStorage ardorDtfAiPick
A cancelable "ardor:dtf-ai-handoff" event (bubbles) fires on the section first; preventDefault() stops the redirect.
Designs are kept in sessionStorage ardorDtfAiHistory (shared with the designer's AI drawer, see dtf/ai/HANDOFF.md). */
(function () {
  'use strict';
  var root = document.querySelector('[data-ardor-dtf-ai]');
  if (!root || root.dataset.dtiReady) return;
  root.dataset.dtiReady = '1';

  var API = String(root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var SITEKEY = String(root.getAttribute('data-turnstile') || '');
  var BUILDER = String(root.getAttribute('data-builder') || '/products/custom-dtf-transfers');
  var MAX = 300, HKEY = 'ardorDtfAiHistory', PKEY = 'ardorDtfAiPick';
  var LOADING = ['Sketching your design…', 'Inking the outlines…', 'Mixing the colors…', 'Drawing 4 versions…', 'Cleaning up the edges…', 'Almost there…'];

  // spots on the shirt, in inches. Front/back: from the centre line (x, + = wearer's left on the front view) and from the
  // high point of the shoulder (y). Width = the designer's preset width; the art is fit inside w x maxH.
  var PL = {
    front: { name: 'Full front', view: 'front', w: 11, maxH: 15, cx: 0, top: 6.1, frame: 'full' },
    leftchest: { name: 'Left chest', view: 'front', w: 3.5, maxH: 4.5, cx: 4, top: 6.6, frame: 'chest' },
    back: { name: 'Full back', view: 'back', w: 12, maxH: 16, cx: 0, top: 3.9, frame: 'full' },
    sleeve: { name: 'Sleeve', view: 'front', w: 3, maxH: 4, cx: 12.38, cy: 7.61, rot: -0.864, frame: 'sleeve' }
  };
  var FRAMES = { full: [-16.9, -1.2, 33.8, 31.6], chest: [-3.5, 0.6, 15, 15], sleeve: [5.6, 0.4, 13, 13] };
  var TEES = [
    ['white', 'White', '#f5f5f2'], ['black', 'Black', '#141416'], ['heather', 'Heather gray', '#a6a8ab'], ['charcoal', 'Charcoal', '#3c3e42'],
    ['navy', 'Navy', '#1c2742'], ['royal', 'Royal blue', '#2a4ea6'], ['red', 'Red', '#c3202c'], ['maroon', 'Maroon', '#5b1a24'],
    ['forest', 'Forest green', '#1f3b2b'], ['kelly', 'Kelly green', '#1d8746'], ['gold', 'Gold', '#f1ae1f'], ['pink', 'Pink', '#f2a6c0']
  ];
  var STYLE_KEYS = ['cartoon', 'retro', 'kawaii', 'text'];

  function $(s, c) { return (c || root).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || root).querySelectorAll(s)); }
  function lget(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function sget(k) { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  function teeOf(k) { for (var i = 0; i < TEES.length; i++) if (TEES[i][0] === k) return TEES[i]; return TEES[1]; }
  function r1(v) { return Math.round(v * 10) / 10; }

  var visitor = lget('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = ((window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    lset('wsIdeaVisitor', visitor);
  }
  var email = lget('wsIdeaEmail') || '';
  var S = {
    style: 'cartoon', placement: 'front', tee: 'black', holes: false,
    idea: '', desc: '', words: '', logo: '', ideaId: '', images: [], selected: null,
    busy: false, ideasLeft: null, editsLeft: null, hasEmail: !!email, freeN: 2, emailN: 10, pending: null, off: false, timer: 0,
    cuts: {}
  };

  var ui = {
    form: $('[data-dti-form]'), desc: $('[data-dti-desc]'), count: $('[data-dti-count]'), words: $('[data-dti-words]'), logo: $('[data-dti-logo]'),
    go: $('[data-dti-go]'), goLabel: $('[data-dti-go-label]'), quota: $('[data-dti-quota]'), err: $('[data-dti-err]'), ts: $('[data-dti-ts]'),
    results: $('[data-dti-results]'), echo: $('[data-dti-echo]'), status: $('[data-dti-status]'), progress: $('[data-dti-progress]'),
    grid: $('[data-dti-grid]'), pick: $('[data-dti-pick]'), pickTee: $('[data-dti-pick-tee]'), pickArt: $('[data-dti-pick-art]'),
    pickSize: $('[data-dti-pick-size]'), pickNote: $('[data-dti-pick-note]'), holes: $('[data-dti-holes]'), use: $('[data-dti-use]'),
    edit: $('[data-dti-edit]'), change: $('[data-dti-change]'), editsEl: $('[data-dti-edits]'), again: $('[data-dti-again]'), fresh: $('[data-dti-new]'),
    history: $('[data-dti-history]'), historyList: $('[data-dti-history-list]'), teeName: $('[data-dti-tee-name]'),
    gate: $('[data-dti-gate]'), gateForm: $('[data-dti-gate-form]'), gateEmail: $('[data-dti-email]'), gateErr: $('[data-dti-gate-err]'), gateN: $('[data-dti-gate-n]')
  };
  if (!ui.form || !ui.desc || !ui.grid) return;
  var MAXD = +ui.desc.getAttribute('maxlength') || 180;
  var holesRow = ui.holes && ui.holes.closest('label');
  if (holesRow) holesRow.hidden = true; // only offered when we removed a plain backdrop ourselves

  // ---------- server (same routes and bodies as assets/ardor-idea.js) ----------
  function api(path, body, ms) {
    var opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) } : {};
    var ctl = window.AbortController ? new AbortController() : null, t = 0;
    if (ctl) { opts.signal = ctl.signal; t = setTimeout(function () { ctl.abort(); }, ms || 150000); }
    return fetch(API + path, opts).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        clearTimeout(t);
        if (!j || typeof j !== 'object') j = {};
        if (!r.ok) { if (!j.error) j = { error: 'server', message: 'Something went wrong on our side. Please try again.' }; j.ok = false; }
        return j;
      });
    }, function (e) {
      clearTimeout(t);
      return e && e.name === 'AbortError' ? { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' } : { ok: false, error: 'network', message: 'Check your connection and try again.' };
    });
  }
  function quota() {
    if (!API) return Promise.resolve({ ok: false });
    return api('/api/quota?visitor=' + encodeURIComponent(visitor) + (email ? '&email=' + encodeURIComponent(email) : ''), null, 20000).then(function (q) {
      if (!q.ok) return q;
      if (q.enabled === false) { S.off = true; setBusy(false); showErr('The design generator is taking a short break. Please try again later.'); }
      S.ideasLeft = q.ideasLeft; S.editsLeft = q.editsLeft; S.hasEmail = !!q.hasEmail;
      if (q.freeIdeas) S.freeN = q.freeIdeas;
      if (q.emailIdeas) S.emailN = q.emailIdeas;
      setQuota();
      return q;
    });
  }

  // ---------- Turnstile: explicit render, invisible, a fresh token for every request ----------
  var tsReady = null, tsWidget = null, tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise(function (res) {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.dtiTurnstileLoaded = function () { res(true); };
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=dtiTurnstileLoaded';
      s.async = true; s.defer = true;
      s.onerror = function () { res(false); };
      document.head.appendChild(s);
    });
    return tsReady;
  }
  function botToken() {
    return loadTurnstile().then(function (ok) {
      if (!ok || !window.turnstile) return '';
      return new Promise(function (res) {
        tsResolve = res;
        var take = function (t) { var r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
        try {
          if (tsWidget === null) tsWidget = window.turnstile.render(ui.ts, { sitekey: SITEKEY, execution: 'execute', appearance: 'interaction-only', callback: take, 'error-callback': function () { take(''); } });
          else window.turnstile.reset(tsWidget);
          window.turnstile.execute(tsWidget);
        } catch (e) { take(''); }
        setTimeout(function () { if (tsResolve === res) take(''); }, 45000);
      });
    });
  }

  // ---------- the t-shirt drawing (inches; y = 0 at the high point of the shoulder) ----------
  function teePath(c) {
    c.beginPath();
    c.moveTo(-3.6, 0);
    c.bezierCurveTo(-3.3, 0.68, -1.9, 0.9, 0, 0.9);
    c.bezierCurveTo(1.9, 0.9, 3.3, 0.68, 3.6, 0);
    c.quadraticCurveTo(6.5, 0.7, 9.3, 1.6);
    c.lineTo(16, 6.2);
    c.quadraticCurveTo(14.5, 9.4, 12.6, 12.3);
    c.quadraticCurveTo(11.4, 10.6, 10.75, 9.6);
    c.quadraticCurveTo(10.6, 19, 10.95, 29);
    c.quadraticCurveTo(0, 29.6, -10.95, 29);
    c.quadraticCurveTo(-10.6, 19, -10.75, 9.6);
    c.quadraticCurveTo(-11.4, 10.6, -12.6, 12.3);
    c.quadraticCurveTo(-14.5, 9.4, -16, 6.2);
    c.lineTo(-9.3, 1.6);
    c.quadraticCurveTo(-6.5, 0.7, -3.6, 0);
    c.closePath();
  }
  function rgbOf(hex) { var n = parseInt(hex.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function lum(hex) { var c = rgbOf(hex); return (0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2]) / 255; }
  function shade(hex, k) {
    var c = rgbOf(hex).map(function (v) { return Math.round(k < 0 ? v * (1 + k) : v + (255 - v) * k); });
    return 'rgb(' + c.join(',') + ')';
  }
  function rng(seed) { return function () { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; }; }
  function radial(c, x, y, r, col, a) {
    var g = c.createRadialGradient(x, y, 0, x, y, r);
    g.addColorStop(0, 'rgba(' + col + ',' + a + ')'); g.addColorStop(1, 'rgba(' + col + ',0)');
    c.fillStyle = g; c.fillRect(x - r, y - r, 2 * r, 2 * r);
  }
  function fold(c, x0, y0, x1, y1, wd, col, a) {
    var dx = x1 - x0, dy = y1 - y0, L = Math.sqrt(dx * dx + dy * dy) || 1, nx = -dy / L, ny = dx / L;
    var g = c.createLinearGradient(x0 - nx * wd, y0 - ny * wd, x0 + nx * wd, y0 + ny * wd);
    g.addColorStop(0, 'rgba(' + col + ',0)'); g.addColorStop(0.5, 'rgba(' + col + ',' + a + ')'); g.addColorStop(1, 'rgba(' + col + ',0)');
    c.fillStyle = g;
    c.beginPath();
    c.moveTo(x0, y0 - 0.01); c.quadraticCurveTo(x0 + nx * wd * 1.4 + dx / 2, y0 + ny * wd * 1.4 + dy / 2, x1, y1);
    c.quadraticCurveTo(x0 - nx * wd * 1.4 + dx / 2, y0 - ny * wd * 1.4 + dy / 2, x0, y0 - 0.01);
    c.fill();
  }
  // size of the art on the shirt (inches) for a spot
  function artSize(pl, aw, ah) {
    var ar = aw / Math.max(1, ah), w = pl.w, h = w / ar;
    if (h > pl.maxH) { h = pl.maxH; w = h * ar; }
    return { w: w, h: h };
  }
  function drawTee(cv, o) {
    var c = cv.getContext('2d'), W = cv.width, H = cv.height, hex = o.hex, pl = PL[o.placement] || PL.front, back = pl.view === 'back';
    var fr = FRAMES[o.frame || pl.frame] || FRAMES.full, k = Math.min(W / fr[2], H / fr[3]);
    var light = lum(hex) > 0.55;
    c.setTransform(1, 0, 0, 1, 0, 0);
    c.clearRect(0, 0, W, H);
    c.setTransform(k, 0, 0, k, (W - fr[2] * k) / 2 - fr[0] * k, (H - fr[3] * k) / 2 - fr[1] * k);
    c.lineJoin = 'round'; c.lineCap = 'round';
    // soft floor shadow
    c.save(); teePath(c); c.shadowColor = 'rgba(0,0,0,.45)'; c.shadowBlur = 0.9 * k; c.shadowOffsetY = 0.35 * k; c.fillStyle = hex; c.fill(); c.restore();
    c.save(); teePath(c); c.clip();
    c.fillStyle = hex; c.fillRect(-17, -2, 34, 33);
    if (o.tee === 'heather') {
      var R = rng(97);
      for (var i = 0; i < 2600; i++) {
        c.fillStyle = R() < 0.5 ? 'rgba(255,255,255,.22)' : 'rgba(40,40,44,.18)';
        c.fillRect(-17 + R() * 34, -1 + R() * 31, 0.05 + R() * 0.12, 0.03 + R() * 0.05);
      }
    }
    if (!back) {
      // inside of the back, seen through the front neck opening
      c.beginPath(); c.moveTo(-3.6, 0);
      c.bezierCurveTo(-3.3, 0.68, -1.9, 0.9, 0, 0.9); c.bezierCurveTo(1.9, 0.9, 3.3, 0.68, 3.6, 0);
      c.bezierCurveTo(3.3, 2.3, 1.9, 3.1, 0, 3.1); c.bezierCurveTo(-1.9, 3.1, -3.3, 2.3, -3.6, 0);
      c.fillStyle = shade(hex, light ? -0.18 : -0.45); c.fill();
      // back collar rib, then the front collar rib
      c.lineWidth = 0.5; c.strokeStyle = shade(hex, light ? -0.08 : 0.06);
      c.beginPath(); c.moveTo(-3.45, 0.15); c.bezierCurveTo(-3.1, 0.85, -1.8, 1.12, 0, 1.12); c.bezierCurveTo(1.8, 1.12, 3.1, 0.85, 3.45, 0.15); c.stroke();
      c.lineWidth = 0.75; c.strokeStyle = shade(hex, light ? -0.06 : 0.07);
      c.beginPath(); c.moveTo(-3.85, 0.05); c.bezierCurveTo(-3.55, 2.65, -2.05, 3.48, 0, 3.48); c.bezierCurveTo(2.05, 3.48, 3.55, 2.65, 3.85, 0.05); c.stroke();
    } else {
      c.lineWidth = 0.7; c.strokeStyle = shade(hex, light ? -0.07 : 0.06);
      c.beginPath(); c.moveTo(-3.75, 0.1); c.bezierCurveTo(-3.4, 0.98, -2, 1.25, 0, 1.25); c.bezierCurveTo(2, 1.25, 3.4, 0.98, 3.75, 0.1); c.stroke();
    }
    // the print
    if (o.art) {
      var s = artSize(pl, o.art.width, o.art.height);
      c.save();
      c.imageSmoothingEnabled = true; try { c.imageSmoothingQuality = 'high'; } catch (e) {}
      if (pl.rot) { c.translate(pl.cx, pl.cy); c.rotate(pl.rot); c.drawImage(o.art, -s.w / 2, -s.h / 2, s.w, s.h); }
      else c.drawImage(o.art, pl.cx - s.w / 2, pl.top, s.w, s.h);
      c.restore();
    }
    // seams and stitching
    var seam = light ? 'rgba(0,0,0,.16)' : 'rgba(255,255,255,.10)';
    c.strokeStyle = seam; c.lineWidth = 0.07;
    [-1, 1].forEach(function (sx) {
      c.beginPath(); c.moveTo(9.3 * sx, 1.6); c.quadraticCurveTo(9.75 * sx, 6.3, 10.75 * sx, 9.6); c.stroke();
    });
    c.setLineDash([0.18, 0.14]); c.lineWidth = 0.05;
    c.beginPath(); c.moveTo(10.92, 28.2); c.quadraticCurveTo(0, 28.8, -10.92, 28.2); c.stroke();
    [-1, 1].forEach(function (sx) { c.beginPath(); c.moveTo(15.39 * sx, 5.68); c.lineTo(11.99 * sx, 11.78); c.stroke(); });
    c.setLineDash([]);
    // light and folds: multiply shows on light shirts, screen on dark ones
    c.globalCompositeOperation = 'multiply';
    var g = c.createLinearGradient(0, 0, 0, 29.5);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,.10)');
    c.fillStyle = g; c.fillRect(-17, -2, 34, 33);
    [-1, 1].forEach(function (sx) {
      fold(c, 10.5 * sx, 9.8, 10.9 * sx, 29.2, 1.5, '0,0,0', 0.14);
      radial(c, 10.2 * sx, 10.6, 3.2, '0,0,0', 0.2);
      fold(c, 10.4 * sx, 10.2, 13.6 * sx, 8.2, 0.55, '0,0,0', 0.12);
    });
    fold(c, -5.2, 15, -6.2, 28.6, 0.7, '0,0,0', 0.09);
    fold(c, 5.8, 17, 4.6, 28.8, 0.6, '0,0,0', 0.08);
    fold(c, 8.6, 11.5, 7.2, 19, 0.5, '0,0,0', 0.08);
    c.globalCompositeOperation = 'screen';
    radial(c, -3.2, 9, 9, '255,255,255', light ? 0.05 : 0.07);
    fold(c, -4.6, 15, -5.5, 28.6, 0.45, '255,255,255', light ? 0.05 : 0.06);
    fold(c, 6.4, 17, 5.2, 28.8, 0.4, '255,255,255', light ? 0.04 : 0.05);
    [-1, 1].forEach(function (sx) { fold(c, 10 * sx, 2.6, 14.6 * sx, 6.6, 0.45, '255,255,255', light ? 0.04 : 0.06); });
    c.globalCompositeOperation = 'source-over';
    c.restore();
    c.lineWidth = Math.max(0.06, 1.2 / k);
    c.strokeStyle = light ? 'rgba(0,0,0,.28)' : 'rgba(255,255,255,.2)';
    teePath(c); c.stroke();
    c.setTransform(1, 0, 0, 1, 0, 0);
  }
  function drawChecker(cv, art) {
    var c = cv.getContext('2d'), W = cv.width, H = cv.height, q = Math.max(6, Math.round(W / 24));
    c.setTransform(1, 0, 0, 1, 0, 0); c.clearRect(0, 0, W, H);
    for (var y = 0; y < H; y += q) for (var x = 0; x < W; x += q) { c.fillStyle = ((x + y) / q) % 2 ? '#d9d9de' : '#f4f4f6'; c.fillRect(x, y, q, q); }
    if (!art) return;
    var k = Math.min((W * 0.86) / art.width, (H * 0.86) / art.height), w = art.width * k, h = art.height * k;
    c.imageSmoothingEnabled = true; try { c.imageSmoothingQuality = 'high'; } catch (e) {}
    c.drawImage(art, (W - w) / 2, (H - h) / 2, w, h);
  }

  // ---------- art: fetch /img/<id>, remove the backdrop (cached per image and option) ----------
  function cutFor(id) {
    var key = id + (S.holes ? ':h' : '');
    if (S.cuts[key]) return S.cuts[key];
    var p;
    if (!window.ArdorDtfCutout) p = Promise.reject(new Error('cutout script missing'));
    else {
      p = fetch(API + '/img/' + id, { mode: 'cors', credentials: 'omit' }).then(function (r) {
        if (!r.ok) throw new Error('gone');
        return r.blob();
      }).then(function (b) { return window.ArdorDtfCutout.cut(b, { holes: S.holes }); });
    }
    // keep the finished cut on its promise, so the hand-off can describe it without waiting; failures are not cached
    p.then(function (r) { p.__res = r; }, function () { if (S.cuts[key] === p) delete S.cuts[key]; });
    S.cuts[key] = p;
    return p;
  }

  // ---------- UI ----------
  function setStyle(st) {
    if (STYLE_KEYS.indexOf(st) < 0) st = 'cartoon';
    S.style = st;
    $$('[data-dti-style]').forEach(function (x) {
      var on = x.getAttribute('data-dti-style') === st;
      x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
    });
  }
  function setPlacement(p, quiet) {
    if (!PL[p]) p = 'front';
    var changed = S.placement !== p;
    S.placement = p;
    $$('[data-dti-place]').forEach(function (x) {
      var on = x.getAttribute('data-dti-place') === p;
      x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
    });
    if (changed) { redrawAll(); if (!quiet) track('ardor_dtf_ai_placement', { placement: p }); }
  }
  function setTee(k) {
    var t = teeOf(k); S.tee = t[0];
    $$('[data-dti-tee]').forEach(function (x) {
      var on = x.getAttribute('data-dti-tee') === S.tee;
      x.setAttribute('aria-checked', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1;
    });
    if (ui.teeName) ui.teeName.textContent = t[1];
    redrawAll();
  }
  function syncCount() { if (ui.count) ui.count.textContent = ui.desc.value.length + '/' + MAXD; }
  function showErr(m, el) { var x = el || ui.err; if (!x) return; x.textContent = m || ''; x.hidden = !m; }
  function setQuota() {
    if (S.ideasLeft == null || !ui.quota) return;
    var n = S.ideasLeft;
    ui.quota.textContent = S.hasEmail
      ? (n > 0 ? n + ' design tr' + (n === 1 ? 'y' : 'ies') + ' left today' : 'No design tries left today')
      : (n > 0 ? n + ' free tr' + (n === 1 ? 'y' : 'ies') + ' · no sign-up' : 'Add your email for ' + S.emailN + ' tries a day');
    if (ui.gateN) ui.gateN.textContent = S.emailN;
    if (ui.editsEl && S.editsLeft != null) ui.editsEl.textContent = S.editsLeft + ' change' + (S.editsLeft === 1 ? '' : 's') + ' left today';
  }
  function setBusy(on, label) {
    S.busy = on;
    ui.go.disabled = on || S.off;
    if (ui.again) ui.again.disabled = on || S.off;
    if (ui.goLabel) ui.goLabel.textContent = on ? (label || 'Drawing…') : 'Design my shirt';
    var cb = ui.edit && ui.edit.querySelector('button'); if (cb) cb.disabled = on || S.off;
  }
  function startLoading(cards) {
    setBusy(true, 'Drawing…');
    ui.results.hidden = false; ui.progress.hidden = false;
    if (cards) {
      ui.grid.innerHTML = '';
      for (var i = 0; i < 4; i++) { var c = document.createElement('div'); c.className = 'ws-idea__card dti__card is-loading'; c.setAttribute('aria-hidden', 'true'); c.innerHTML = '<span class="ws-idea__blob"></span>'; ui.grid.appendChild(c); }
      ui.pick.hidden = true;
    }
    var t0 = Date.now(), k = 0, fill = ui.progress.firstElementChild;
    ui.status.textContent = LOADING[0];
    clearInterval(S.timer);
    S.timer = setInterval(function () {
      var t = (Date.now() - t0) / 1000;
      if (fill) fill.style.width = Math.min(94, 100 * (1 - Math.exp(-t / 14))) + '%';
      var kk = Math.min(LOADING.length - 1, Math.floor(t / 5));
      if (kk !== k) { k = kk; ui.status.textContent = LOADING[k]; }
    }, 250);
    try { ui.results.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }
  function stopLoading() {
    clearInterval(S.timer);
    ui.progress.hidden = true;
    if (ui.progress.firstElementChild) ui.progress.firstElementChild.style.width = '0';
    setBusy(false);
  }

  function sizeLabel(cut) {
    var s = artSize(PL[S.placement], cut.w, cut.h);
    return r1(s.w) + ' x ' + r1(s.h) + ' in';
  }
  function cardFor(img, i) {
    var c = document.createElement('button');
    c.type = 'button'; c.className = 'ws-idea__card dti__card';
    c.setAttribute('role', 'option'); c.setAttribute('aria-selected', 'false'); c.dataset.id = img.id;
    c.setAttribute('aria-label', 'Shirt design ' + (i + 1));
    c.innerHTML = '<canvas class="dti__tee" width="640" height="640" aria-hidden="true"></canvas><span class="ws-idea__check" aria-hidden="true">✓</span><span class="dti__size" data-dti-size></span>';
    c.addEventListener('click', function () { select(img.id); });
    paintCard(c, img.id);
    return c;
  }
  function paintCard(c, id) {
    var cv = c.querySelector('canvas'), t = teeOf(S.tee), pl = S.placement, tee = S.tee;
    c.classList.add('is-cutting');
    drawTee(cv, { hex: t[2], tee: tee, placement: pl, art: null });
    return cutFor(id).then(function (cut) {
      if (pl !== S.placement || tee !== S.tee) return; // a newer redraw will paint it
      drawTee(cv, { hex: t[2], tee: tee, placement: pl, art: cut.canvas });
      c.classList.remove('is-cutting'); c.classList.add('is-in');
      c.classList.toggle('has-bg', !cut.plain);
      var sz = c.querySelector('[data-dti-size]'); if (sz) sz.textContent = sizeLabel(cut);
      c.setAttribute('aria-label', 'Shirt design, ' + PL[pl].name.toLowerCase() + ', ' + sizeLabel(cut));
    }, function () {
      c.classList.remove('is-cutting'); c.classList.add('is-broken'); c.disabled = true;
    });
  }
  function renderResults(note) {
    ui.echo.textContent = S.idea.replace(/ \(changed: .*\)$/, '');
    ui.grid.innerHTML = '';
    if (!S.images.length) { ui.results.hidden = true; return; }
    ui.results.hidden = false;
    S.images.forEach(function (img, i) { ui.grid.appendChild(cardFor(img, i)); });
    ui.status.textContent = note || (S.images.length > 1 ? 'Tap the one you like best.' : 'Here you go. Tap it to use it.');
    if (S.selected && S.images.some(function (x) { return x.id === S.selected; })) select(S.selected, true);
    else ui.pick.hidden = true;
  }
  function redrawAll() {
    $$('.dti__card[data-id]', ui.grid).forEach(function (c) { paintCard(c, c.dataset.id); });
    if (S.selected && !ui.pick.hidden) renderPick();
  }
  function handoffUrl(id) {
    return BUILDER + (BUILDER.indexOf('?') < 0 ? '?' : '&') + 'ai=' + encodeURIComponent(id) + '&src=sticker&placement=' + encodeURIComponent(S.placement);
  }
  function renderPick() {
    var id = S.selected, t = teeOf(S.tee), pl = S.placement, tee = S.tee, holes = S.holes;
    if (!id) return;
    ui.use.href = handoffUrl(id);
    drawTee(ui.pickTee, { hex: t[2], tee: tee, placement: pl, art: null, frame: 'full' });
    drawChecker(ui.pickArt, null);
    ui.pickSize.textContent = '';
    ui.pickNote.textContent = '';
    ui.pickNote.classList.remove('is-warn');
    cutFor(id).then(function (cut) {
      if (id !== S.selected || pl !== S.placement || tee !== S.tee || holes !== S.holes) return;
      drawTee(ui.pickTee, { hex: t[2], tee: tee, placement: pl, art: cut.canvas, frame: 'full' });
      drawChecker(ui.pickArt, cut.canvas);
      ui.pickSize.textContent = PL[pl].name + ': about ' + sizeLabel(cut) + '. You can change the size in the designer.';
      ui.pickNote.textContent = !cut.plain
        ? 'We could not find a plain background to remove on this design, so it would print as a block. Pick another design or ask for a change.'
        : (cut.hadAlpha ? 'Transparent background. The checkered area does not print.' : 'Background removed. The checkered area is transparent and does not print.');
      ui.pickNote.classList.toggle('is-warn', !cut.plain);
      if (holesRow) holesRow.hidden = !(cut.plain && !cut.hadAlpha);
    }, function () {
      ui.pickNote.textContent = 'We couldn\'t load this design. It may have expired. Try another one or make new ones.';
      ui.pickNote.classList.add('is-warn');
    });
  }
  function select(id, quiet) {
    var img = S.images.filter(function (x) { return x.id === id; })[0];
    if (!img) return;
    S.selected = id;
    $$('.dti__card[data-id]', ui.grid).forEach(function (c) {
      var on = c.dataset.id === id;
      c.classList.toggle('is-selected', on); c.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    ui.pick.hidden = false;
    renderPick();
    setQuota();
    if (!quiet) {
      remember();
      track('ardor_dtf_ai_selected', { style: S.style, placement: S.placement });
      try { ui.pick.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
    }
  }
  function remember() {
    if (!S.ideaId && !S.images.length) return;
    var hist = sget(HKEY);
    if (!Array.isArray(hist)) hist = [];
    var key = S.ideaId || (S.images[0] && S.images[0].id);
    var entry = { ideaId: key, idea: S.idea, desc: S.desc, words: S.words, logo: S.logo, style: S.style, placement: S.placement, tee: S.tee, images: S.images.slice(0, 8), selected: S.selected, at: Date.now() };
    sset(HKEY, [entry].concat(hist.filter(function (h) { return h && h.ideaId !== key; })).slice(0, 6));
    renderHistory();
  }
  function renderHistory() {
    var hist = sget(HKEY);
    if (!ui.history || !Array.isArray(hist)) return;
    var others = hist.filter(function (h) { return h && h.images && h.images.length && h.ideaId !== (S.ideaId || (S.images[0] && S.images[0].id)); });
    ui.historyList.innerHTML = '';
    others.forEach(function (h) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'dti__hist';
      b.innerHTML = '<span class="dti__hist-art"><img alt="" loading="lazy" decoding="async"></span><span class="dti__hist-text"></span>';
      b.querySelector('img').src = h.images[0].url || (API + '/img/' + h.images[0].id);
      b.querySelector('img').addEventListener('error', function () { b.hidden = true; });
      b.querySelector('.dti__hist-text').textContent = String(h.idea || '').replace(/ \(changed: .*\)$/, '');
      b.addEventListener('click', function () { restore(h, true); });
      ui.historyList.appendChild(b);
    });
    ui.history.hidden = !others.length;
  }
  function restore(h, scroll) {
    S.ideaId = h.ideaId || ''; S.idea = String(h.idea || ''); S.images = (h.images || []).slice(0, 8); S.selected = h.selected || null;
    S.desc = h.desc || ''; S.words = h.words || ''; S.logo = h.logo || '';
    setStyle(h.style || 'cartoon');
    if (h.placement && PL[h.placement]) setPlacement(h.placement, true);
    ui.desc.value = String(h.desc != null ? h.desc : S.idea.replace(/ \(changed: .*\)$/, '')).slice(0, MAXD); syncCount();
    if (ui.words) ui.words.value = h.words || '';
    if (ui.logo) ui.logo.value = h.logo || '';
    renderResults(scroll ? 'Your earlier designs. Tap one to use it.' : 'Your latest designs. Tap one to use it.');
    renderHistory();
    if (scroll) { try { ui.results.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
  }

  // ---------- email unlock (same as the sticker generator) ----------
  function openGate() {
    showErr('', ui.gateErr);
    if (ui.gateEmail) ui.gateEmail.value = email || '';
    if (ui.gate.showModal) { try { ui.gate.showModal(); } catch (e) { ui.gate.setAttribute('open', ''); } }
    else ui.gate.setAttribute('open', '');
    setTimeout(function () { try { ui.gateEmail.focus(); } catch (e) {} }, 60);
    track('ardor_dtf_ai_gate_shown', {});
  }
  function closeGate() { if (ui.gate.close) { try { ui.gate.close(); } catch (e) { ui.gate.removeAttribute('open'); } } else ui.gate.removeAttribute('open'); }
  function subscribe(addr) {
    var f = document.getElementById('dti-customer');
    if (!f) return;
    var field = f.querySelector('[name="contact[email]"]'); if (field) field.value = addr;
    f.target = 'dti-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (er) {} }
  }
  function useEmail(e) {
    if (e) e.preventDefault();
    var addr = clean(ui.gateEmail.value);
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { showErr('Please enter a valid email.', ui.gateErr); ui.gateEmail.focus(); return; }
    showErr('', ui.gateErr);
    email = addr; lset('wsIdeaEmail', addr); S.hasEmail = true;
    subscribe(addr);
    track('ardor_dtf_ai_email', {});
    api('/api/quota?visitor=' + encodeURIComponent(visitor) + '&email=' + encodeURIComponent(addr), null, 20000).then(function (q) {
      if (q.ok) { S.ideasLeft = q.ideasLeft; S.editsLeft = q.editsLeft; }
      setQuota(); closeGate();
      var next = S.pending; S.pending = null;
      if (next && (S.ideasLeft == null || S.ideasLeft > 0)) next();
    });
  }

  // ---------- 4 designs ----------
  function compose() {
    var desc = clean(ui.desc.value).slice(0, MAXD), words = clean(ui.words ? ui.words.value : ''), logo = clean(ui.logo ? ui.logo.value : '');
    var tail = (words ? ' The words "' + words.replace(/"/g, '\'') + '".' : '') + (logo ? ' Logo or photo idea: ' + logo.replace(/[.!\s]+$/, '') + '.' : '');
    var d = desc.slice(0, Math.max(0, MAX - tail.length - 1)).replace(/[.\s]+$/, '');
    var idea = ((d ? d + '.' : '') + tail).trim().slice(0, MAX);
    return { idea: idea, desc: desc, words: words, logo: logo, ok: !!(d.length >= 3 || words.length >= 2) };
  }
  function generate(again) {
    if (S.busy || S.off) return;
    var c = again ? { idea: S.idea.replace(/ \(changed: .*\)$/, ''), desc: S.desc, words: S.words, logo: S.logo, ok: !!S.idea } : compose();
    if (!c.ok || c.idea.length < 3) { showErr('Tell us what to put on your shirt: describe the design or type the words.'); ui.desc.focus(); return; }
    showErr('');
    if (!API) { showErr('The design generator is not available right now. Please try again later.'); return; }
    if (!S.hasEmail && S.ideasLeft === 0) { S.pending = function () { generate(again); }; openGate(); return; }
    var prev = { ideaId: S.ideaId, idea: S.idea, images: S.images, selected: S.selected, desc: S.desc, words: S.words, logo: S.logo };
    S.idea = c.idea; S.desc = c.desc; S.words = c.words; S.logo = c.logo;
    ui.echo.textContent = c.idea;
    startLoading(true);
    botToken().then(function (token) {
      return api('/api/generate', { idea: c.idea, style: S.style, visitor: visitor, email: S.hasEmail ? email : '', token: token });
    }).then(function (j) {
      stopLoading();
      if (j.ideasLeft != null) S.ideasLeft = j.ideasLeft;
      if (!j.ok || !j.images || !j.images.length) {
        S.ideaId = prev.ideaId; S.idea = prev.idea; S.images = prev.images; S.selected = prev.selected; S.desc = prev.desc; S.words = prev.words; S.logo = prev.logo;
        renderResults();
        if (j.error === 'need_email') { S.ideasLeft = 0; setQuota(); S.pending = function () { generate(again); }; openGate(); return; }
        showErr(j.message || 'We couldn\'t draw that one. Please try again.');
        setQuota();
        return;
      }
      S.ideaId = j.ideaId || ''; S.idea = j.idea || c.idea; S.images = j.images.slice(0, 8); S.selected = null;
      if (j.editsLeft != null) S.editsLeft = j.editsLeft;
      if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
      setQuota(); renderResults('Removing the backgrounds…');
      remember();
      Promise.all(S.images.map(function (im) { return cutFor(im.id).then(function () { return 1; }, function () { return 0; }); })).then(function (ok) {
        if (S.busy) return;
        var n = ok.reduce(function (a, b) { return a + b; }, 0);
        ui.status.textContent = n ? (n > 1 ? 'Tap the one you like best.' : 'Here you go. Tap it to use it.') : 'We couldn\'t load these designs. Please try again.';
      });
      track('ardor_dtf_ai_generated', { style: S.style, placement: S.placement, again: !!again });
    });
  }
  function editDesign(e) {
    if (e) e.preventDefault();
    if (S.busy || S.off || !S.selected) return;
    var change = clean(ui.change.value).slice(0, 240);
    if (change.length < 2) { ui.change.focus(); return; }
    if (!S.hasEmail && S.editsLeft === 0) { S.pending = function () { editDesign(); }; openGate(); return; }
    var before = S.images.slice();
    startLoading(false);
    var ph = document.createElement('div');
    ph.className = 'ws-idea__card dti__card is-loading'; ph.innerHTML = '<span class="ws-idea__blob"></span>';
    ui.grid.insertBefore(ph, ui.grid.firstChild);
    ui.status.textContent = 'Making your change…';
    botToken().then(function (token) {
      return api('/api/edit', { imageId: S.selected, change: change, visitor: visitor, email: S.hasEmail ? email : '', token: token });
    }).then(function (j) {
      stopLoading();
      if (ph.parentNode) ph.parentNode.removeChild(ph);
      if (j.editsLeft != null) S.editsLeft = j.editsLeft;
      if (!j.ok || !j.images || !j.images.length) {
        S.images = before; renderResults();
        if (j.error === 'need_email') { S.pending = function () { editDesign(); }; openGate(); return; }
        ui.status.textContent = j.message || 'That change did not work. Try again.';
        setQuota();
        return;
      }
      S.images = j.images.concat(before).slice(0, 8);
      S.selected = j.images[0].id;
      S.idea = S.idea.replace(/ \(changed: .*\)$/, '');
      ui.change.value = '';
      renderResults(); select(S.selected, true); remember(); setQuota();
      ui.status.textContent = 'Here is your change. The originals are still below.';
      track('ardor_dtf_ai_changed', { style: S.style, placement: S.placement });
    });
  }

  // ---------- hand-off to the DTF transfer designer ----------
  function onUse(e) {
    var id = S.selected, img = S.images.filter(function (x) { return x.id === id; })[0];
    if (!img || !/^[a-f0-9]{32}$/.test(id)) { e.preventDefault(); return; }
    var url = handoffUrl(id), t = teeOf(S.tee), pl = PL[S.placement];
    var pick = {
      v: 1, ai: id, src: 'sticker', url: API + '/img/' + id, ideaId: S.ideaId, idea: S.idea, desc: S.desc, words: S.words, logo: S.logo,
      style: S.style, placement: S.placement, placementName: pl.name, tee: { key: t[0], name: t[1], hex: t[2] },
      cutout: { v: window.ArdorDtfCutout ? window.ArdorDtfCutout.version : 0, opts: { holes: S.holes } }, at: Date.now()
    };
    var done = S.cuts[id + (S.holes ? ':h' : '')];
    pick.sizeIn = null;
    if (done && done.__res) {
      var c = done.__res, s = artSize(pl, c.w, c.h);
      pick.sizeIn = { w: Math.round(s.w * 100) / 100, h: Math.round(s.h * 100) / 100 };
      pick.cutout.plain = c.plain; pick.cutout.hadAlpha = c.hadAlpha; pick.cutout.ref = c.ref;
      pick.cutout.srcW = c.srcW; pick.cutout.srcH = c.srcH; pick.cutout.w = c.w; pick.cutout.h = c.h; pick.cutout.bbox = c.bbox;
    }
    ui.use.href = url;
    sset(PKEY, pick);
    remember();
    track('ardor_dtf_ai_design_used', { style: S.style, placement: S.placement, tee: S.tee });
    var ev;
    try { ev = new CustomEvent('ardor:dtf-ai-handoff', { bubbles: true, cancelable: true, detail: { url: url, pick: pick } }); }
    catch (er) { ev = document.createEvent('CustomEvent'); ev.initCustomEvent('ardor:dtf-ai-handoff', true, true, { url: url, pick: pick }); }
    if (!root.dispatchEvent(ev)) e.preventDefault();
  }

  // ---------- wiring ----------
  function radioKeys(group, attr, set) {
    if (!group) return;
    group.addEventListener('keydown', function (e) {
      if (['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      e.preventDefault();
      var btns = $$('[' + attr + ']', group), i = btns.indexOf(document.activeElement); if (i < 0) i = 0;
      var nx = btns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + btns.length) % btns.length];
      set(nx.getAttribute(attr)); nx.focus();
    });
  }
  ui.form.addEventListener('submit', function (e) { e.preventDefault(); generate(false); });
  ui.desc.addEventListener('input', function () { syncCount(); showErr(''); });
  ui.desc.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); generate(false); } });
  root.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button, a');
    if (!b || !root.contains(b)) return;
    if (b.hasAttribute('data-dti-example')) { ui.desc.value = b.getAttribute('data-dti-example').slice(0, MAXD); syncCount(); showErr(''); ui.desc.focus(); return; }
    if (b.hasAttribute('data-dti-style')) { setStyle(b.getAttribute('data-dti-style')); return; }
    if (b.hasAttribute('data-dti-place')) { setPlacement(b.getAttribute('data-dti-place')); return; }
    if (b.hasAttribute('data-dti-tee')) { setTee(b.getAttribute('data-dti-tee')); return; }
  });
  radioKeys($('[data-dti-styles]'), 'data-dti-style', setStyle);
  radioKeys($('[data-dti-places]'), 'data-dti-place', setPlacement);
  radioKeys($('[data-dti-tees]'), 'data-dti-tee', setTee);
  if (ui.again) ui.again.addEventListener('click', function () { generate(true); });
  if (ui.fresh) ui.fresh.addEventListener('click', function () {
    ui.desc.value = ''; if (ui.words) ui.words.value = ''; if (ui.logo) ui.logo.value = ''; syncCount();
    try { ui.form.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    setTimeout(function () { try { ui.desc.focus({ preventScroll: true }); } catch (e) {} }, 350);
  });
  if (ui.edit) ui.edit.addEventListener('submit', editDesign);
  if (ui.use) ui.use.addEventListener('click', onUse);
  if (ui.holes) ui.holes.addEventListener('change', function () { S.holes = !!ui.holes.checked; redrawAll(); });
  if (ui.gateForm) ui.gateForm.addEventListener('submit', useEmail);
  var gx = $('[data-dti-gate-close]'); if (gx) gx.addEventListener('click', closeGate);
  if (ui.gate) ui.gate.addEventListener('click', function (e) { if (e.target === ui.gate) closeGate(); });

  // ---------- start ----------
  (function start() {
    var q = {};
    try { new URLSearchParams(window.location.search).forEach(function (v, k) { q[k] = v; }); } catch (e) {}
    setStyle('cartoon');
    var pq = String(q.placement || '').toLowerCase().replace(/[^a-z]/g, '');
    if (pq === 'chest' || pq === 'leftchest' || pq === 'pocket') pq = 'leftchest';
    if (pq === 'fullfront') pq = 'front';
    if (pq === 'fullback') pq = 'back';
    if (pq === 'sleevel' || pq === 'sleever' || pq === 'leftsleeve' || pq === 'rightsleeve') pq = 'sleeve';
    S.placement = '';
    setPlacement('front', true);
    setTee(q.tee || q.color || 'black');
    var last = (sget(HKEY) || [])[0];
    if (last && last.images && last.images.length) restore(last, false);
    if (PL[pq]) setPlacement(pq, true); // the address wins over the last designs
    if (q.idea) { ui.desc.value = clean(q.idea).slice(0, MAXD); }
    syncCount();
    renderHistory();
    setBusy(false);
    if (!API) { S.off = true; setBusy(false); showErr('The design generator is not available right now. Please try again later.'); return; }
    quota();
    loadTurnstile();
  })();

  window.ArdorDtfAI = { state: S, PL: PL, TEES: TEES, FRAMES: FRAMES, drawTee: drawTee, artSize: artSize, cutFor: function (id) { return cutFor(id); },
    generate: generate, select: select, setPlacement: setPlacement, setTee: setTee, setStyle: setStyle, quota: quota, compose: compose, handoffUrl: handoffUrl };
})();
